import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class CrashMessageService {
     message$ = new BehaviorSubject<string>(null);

     constructor() {}

     setMessage(message) {
          this.message$.next(message);
     }
}
